'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _dec2, _class; // Lib


// Utils


// Selectors


// Components


// Measurements


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reselect = require('reselect');

var _point = require('../../../common/maths/geometry/point');

var pointLib = _interopRequireWildcard(_point);

var _lineUtil = require('./lineUtil');

var _lineSnapAngleUtil = require('./lineSnapAngleUtil');

var _elementSelector = require('../elementSelector');

var _lineSelector = require('./lineSelector');

var _Line = require('./Line');

var _Line2 = _interopRequireDefault(_Line);

var _measurementsSelector = require('../../components/measurements/measurementsSelector');

var _measurementsConnect = require('../../components/measurements/measurementsConnect');

var _measurementsConnect2 = _interopRequireDefault(_measurementsConnect);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// TODO Return only the required measurements (the ones that the line edges require)
var mapMeasurementsStateToProps = function mapMeasurementsStateToProps(connectionsState) {
    return {
        measurements: (0, _measurementsSelector.getMeasurementsMap)(connectionsState)
    };
};

var updateFlexiblePoint = function updateFlexiblePoint(_ref) {
    var offsetDiff = _ref.offsetDiff,
        pos = _ref.pos,
        shouldSnapToAngle = _ref.shouldSnapToAngle,
        fixedPointOrigin = _ref.fixedPointOrigin;

    var flexiblePoint = pointLib.translate(offsetDiff, pos);

    if (shouldSnapToAngle) {
        flexiblePoint = (0, _lineSnapAngleUtil.getEndpointSnappedToAngle)({ fixedPoint: fixedPointOrigin, flexiblePoint: flexiblePoint });
    }

    return flexiblePoint;
};

/**
 * Updates the start, end and control point positions based on which end of the line is being dragged.
 */
var getUpdatedEdges = (0, _reselect.createSelector)((0, _lineSelector.makeGetLineEdgeDetails)(), _lineSelector.getLineControl, function (state, ownProps) {
    return ownProps.draggedEdge;
}, function (state, ownProps) {
    return ownProps.offsetDiff;
}, function (state, ownProps) {
    return ownProps.pos;
}, function (state, ownProps) {
    return ownProps.shouldSnapToAngle;
}, function (_ref2, control, draggedEdge, offsetDiff, pos, shouldSnapToAngle) {
    var startEdgeOrigin = _ref2.startEdgeOrigin,
        startConnectionRect = _ref2.startConnectionRect,
        endEdgeOrigin = _ref2.endEdgeOrigin,
        endConnectionRect = _ref2.endConnectionRect;

    var fixedPointOrigin = (0, _lineUtil.isEndEdge)(draggedEdge) ? startEdgeOrigin : endEdgeOrigin;
    var flexiblePoint = updateFlexiblePoint({ offsetDiff: offsetDiff, pos: pos, shouldSnapToAngle: shouldSnapToAngle, fixedPointOrigin: fixedPointOrigin });

    var start = (0, _lineUtil.isEndEdge)(draggedEdge) ? fixedPointOrigin : flexiblePoint;
    var end = (0, _lineUtil.isEndEdge)(draggedEdge) ? flexiblePoint : fixedPointOrigin;

    var _startConnectionRect = (0, _lineUtil.isEndEdge)(draggedEdge) ? startConnectionRect : undefined;
    var _endConnectionRect = (0, _lineUtil.isEndEdge)(draggedEdge) ? undefined : endConnectionRect;

    var controlPoint = (0, _lineSelector.getControlPosition)({ start: start, end: end, control: control });

    return (0, _lineUtil.getLinePointsOfInterest)({
        startEdgeOrigin: start,
        startConnectionRect: _startConnectionRect,
        endEdgeOrigin: end,
        endConnectionRect: _endConnectionRect,
        controlPoint: controlPoint
    });
});

var makeMapStateToProps = function makeMapStateToProps() {
    return (0, _reselect.createSelector)(_elementSelector.getElementId, getUpdatedEdges, _elementSelector.getColourHex, _lineSelector.getLineStartStyle, _lineSelector.getLineEndStyle, _lineSelector.getIsLineStartSnapped, _lineSelector.getIsLineEndSnapped, function (state, ownProps) {
        return ownProps.draggedEdge;
    }, function (elementId, _ref3, colorHex, startStyle, endStyle, startSnapped, endSnapped, draggedEdge) {
        var start = _ref3.start,
            end = _ref3.end,
            controlPoint = _ref3.controlPoint;
        return {
            elementId: elementId,
            start: start,
            end: end,
            controlPoint: controlPoint,
            colorHex: colorHex,
            startStyle: startStyle,
            endStyle: endStyle,
            startSnapped: startSnapped && !(0, _lineUtil.isStartEdge)(draggedEdge),
            endSnapped: endSnapped && !(0, _lineUtil.isEndEdge)(draggedEdge)
        };
    });
};

var LineDragPreview = (_dec = (0, _measurementsConnect2.default)(mapMeasurementsStateToProps), _dec2 = (0, _reactRedux.connect)(makeMapStateToProps), _dec(_class = _dec2(_class = function (_React$Component) {
    _inherits(LineDragPreview, _React$Component);

    function LineDragPreview() {
        _classCallCheck(this, LineDragPreview);

        return _possibleConstructorReturn(this, (LineDragPreview.__proto__ || Object.getPrototypeOf(LineDragPreview)).apply(this, arguments));
    }

    _createClass(LineDragPreview, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(_Line2.default, _extends({}, this.props, { isPresentational: true, isSelected: true }));
        }
    }]);

    return LineDragPreview;
}(_react2.default.Component)) || _class) || _class);


LineDragPreview.propTypes = {
    elementId: _propTypes2.default.string.isRequired,
    draggedEdge: _propTypes2.default.string.isRequired,
    offsetDiff: _propTypes2.default.object
};

exports.default = LineDragPreview;


//////////////////
// WEBPACK FOOTER
// ./src/client/element/line/LineDragPreview.js
// module id = 1992
// module chunks = 0